import { checkDate } from "common/helpers/Date";
import { Nullable } from "common/records";
import { ITaskData } from "common/records/Task";
import { Record, List, Map } from "immutable";
import { fromJS } from "immutable";

export const reportFromJSON = (json: Partial<IReportData>): ReportRecord => {
  const data: Partial<IReportRecord> = { ...(json as any) };
  if (json.task) {
    data.task_id = json.task.id;
  }

  if (json.created_at) {
    data.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    data.updated_at = checkDate(json.updated_at);
  }

  if (json.delivered_at) {
    data.delivered_at = checkDate(json.delivered_at);
  }

  if (json.metadata) {
    data.metadata = fromJS(json.metadata);
  }
  if (json.order_data) {
    data.order_data = fromJS(json.order_data);
  }
  if (json.order_result) {
    data.order_result = fromJS(json.order_result);
  }
  return new ReportRecord(data);
};

export type ReportKind = "roofing" | "walls" | "interior";
export type ReportProvider = "eagleview" | "quick_measure" | "roof_scope" | "plnar";
export type ReportStatus =
  | "created"
  | "ordered"
  | "exception"
  | "canceled"
  | "complete"
  | "paid"
  | "refunded"
  | "partially_refunded";

export interface IReportData {
  id: number;
  kind: ReportKind;
  provider: ReportProvider;
  status: ReportStatus;
  metadata: any;
  order_data: any;
  order_result: any;
  user_id: Nullable<number>;
  org_id: Nullable<number>;
  job_id: Nullable<number>;
  task?: ITaskData;
  task_id?: string;
  loading?: boolean;

  delivered_at: Nullable<Date>;
  created_at: string;
  updated_at: string;
}

export interface IReportRecord {
  id: number;
  kind: Nullable<ReportKind>;
  provider: Nullable<ReportProvider>;
  status: Nullable<ReportStatus>;
  metadata: Map<any, any>;
  order_data: Map<any, any>;
  order_result: Map<any, any>;
  user_id: Nullable<number>;
  org_id: Nullable<number>;
  job_id: Nullable<number>;
  task_id: Nullable<string>;
  loading: boolean;
  errors: List<string>;

  delivered_at: Nullable<Date>;
  created_at: Date;
  updated_at: Date;
}

const defaultReportProps: IReportRecord = {
  id: 0,
  kind: null,
  provider: null,
  status: null,
  metadata: Map({}),
  order_data: Map({}),
  order_result: Map({}),
  user_id: null,
  org_id: null,
  job_id: null,
  task_id: null,
  loading: false,
  errors: List<string>(),
  delivered_at: null,
  created_at: new Date(),
  updated_at: new Date(),
};

export class ReportRecord extends Record(defaultReportProps) implements IReportRecord {}
